import { OrderedMap } from 'immutable';
import Occasion from '@support/Occasion';
import { ID } from '@app/types';
import { ShareStatus } from '@models/ShareStatus';
import { Sharee } from '@models/Sharee';

export function fetchAllShareesSucceeded<P>(
  state: OrderedMap<ID, ShareStatus<P>>,
  payload,
  ShareStatus: { new (shareStatusData: any): ShareStatus<P> },
) {
  return state.update(
    payload.sharedResourceID,
    new ShareStatus({ id: payload.sharedResourceID, ...payload, updated: new Occasion() }),
    (shareStatus) => shareStatus.copyWith({ ...payload, updated: new Occasion() }),
  );
}

export function updatePublicSharingRequested<P>(state: OrderedMap<ID, ShareStatus<P>>, payload) {
  return state.update(payload.shareStatus.id, (shareStatus) =>
    shareStatus.copyWith({
      publiclyShared: payload.shareStatus.publiclyShared,
      publicPermissionsMap: payload.shareStatus.publicPermissionsMap,
    }),
  );
}

export function createShareeRequested<P>(state: OrderedMap<ID, ShareStatus<P>>, payload) {
  return state.update(payload.sharedResourceID, (shareStatus) =>
    shareStatus.addShareePermission(payload.email, payload.permission),
  );
}

export function createShareeSucceeded<P>(
  state: OrderedMap<ID, ShareStatus<P>>,
  payload,
  Sharee: { new (shareeData: any): Sharee<P> },
) {
  return state.update(payload.sharedResourceID, (shareStatus) =>
    shareStatus.setSharee(new Sharee(payload.response[0])),
  );
}

export function deleteShareePermissionRequested<P>(state: OrderedMap<ID, ShareStatus<P>>, payload) {
  if (payload.removeAllAccess) {
    return state.update(payload.sharedResourceID, (shareStatus) =>
      shareStatus?.removeSharee(payload.sharee),
    );
  } else {
    return state.update(payload.sharedResourceID, (shareStatus) =>
      shareStatus?.removeShareePermissionID(payload.sharee, payload.permissionID),
    );
  }
}
